import { styled } from "@mui/material";

import { Button } from "@components/base";

// TODO: delete
export const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: "none",
  padding: theme.spacing(2.5),
  textAlign: "left",
  width: "320px",
  backgroundColor: theme.palette.custom.purple[50],
  justifyContent: "flex-start",
  transition: "box-shadow 0.2s ease",
  "&:hover": {
    boxShadow: theme.shadows[4],
  },
}));
